import { getIdentifierName } from './LocalStorage'

export const searchTruncatedUsers = [
		{
				key: 'name',
				label: 'Nome',
				type: 'text',
				value: ''
		},
		{
				key: 'cpf',
				label: 'Cpf',
				type: 'text',
				value: '',
				mask: '000.000.000-00'
		},
		{
				key: 'email',
				label: 'Email',
				type: 'text',
				value: '',
				mask: 'A*@A*.SSS'
		},
		{
				key: 'phone',
				label: 'Telefone',
				type: 'text',
				value: '',
				mask: '(00) 00000-0000'
		}
]

export const searchTruncatedCompanyServiceProvider = [
		{
				key: 'socialName',
				label: 'Razão social',
				type: 'text',
				value: ''
		},
		{
				key: 'cnpj',
				label: 'Cnpj',
				type: 'text',
				value: '',
				mask: '00.000.000/0000-00'
		},
		{
				key: 'address',
				label: 'Endereço',
				type: 'text',
				value: ''
		}
]

export const searchTruncatedInventorySchedule = [
		{
				key: 'identifier',
				label: getIdentifierName(),
				type: 'text',
				value: ''
		},
		{
				key: 'treeId',
				label: 'Id Árvore',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'data',
				label: 'Data',
				type: 'date',
				value: ''
		},
		{
				key: 'address',
				label: 'Endereço',
				type: 'text',
				value: ''
		},
		{
				key: 'generalState',
				label: 'Estado Geral',
				type: 'text',
				value: ''
		},
		{
				key: 'management',
				label: 'Manejo',
				type: 'text',
				value: ''
		},
		{
				key: 'operation',
				label: 'Operação',
				type: 'text',
				value: ''
		},
		{
				key: 'osa',
				label: 'OSA',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'schedule',
				label: 'Agendamento',
				type: 'date',
				value: ''
		},
		{
				key: 'evaluator',
				label: 'Avaliador',
				type: 'text',
				value: ''
		}
]

export const searchTruncatedInventoryHistory = [
		{
				key: 'process',
				label: 'Processo',
				type: 'text',
				value: ''
		},
		{
				key: 'identifier',
				label: getIdentifierName(),
				type: 'text',
				value: ''
		},
		{
				key: 'treeId',
				label: 'Id Árvore',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'data',
				label: 'Data',
				type: 'date',
				value: ''
		},
		{
				key: 'address',
				label: 'Endereço',
				type: 'text',
				value: ''
		},
		{
				key: 'generalState',
				label: 'Estado Geral',
				type: 'text',
				value: ''
		},
		{
				key: 'specie',
				label: 'Espécie',
				type: 'text',
				value: ''
		},
		{
				key: 'management',
				label: 'Manejo',
				type: 'text',
				value: ''
		},
		{
				key: 'operation',
				label: 'Operação',
				type: 'text',
				value: ''
		},
		{
				key: 'osa',
				label: 'OSA',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'oso',
				label: 'OSO',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		}
]

export const searchTruncatedPlantingSchedule = [
		{
				key: 'osp',
				label: 'OPO',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'data',
				label: 'Data',
				type: 'date',
				value: ''
		},
		{
				key: 'address',
				label: 'Endereço',
				type: 'text',
				value: ''
		}
]

export const searchTruncatedPlantingHistory = [
		{
				key: 'osp',
				label: 'OPO',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'treeId',
				label: 'Id Árvore',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'data',
				label: 'Data',
				type: 'date',
				value: ''
		},
		{
				key: 'address',
				label: 'Endereço',
				type: 'text',
				value: ''
		},
		{
				key: 'specie',
				label: 'Espécie',
				type: 'text',
				value: ''
		},
		{
				key: 'oso',
				label: 'OSO',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'operator',
				label: 'Operador',
				type: 'text',
				value: ''
		},
		{
				key: 'companyServiceProvider',
				label: 'Empresa',
				type: 'text',
				value: ''
		}
]

export const searchTruncatedDemandSchedule = [
		{
				key: 'process',
				label: 'Processo',
				type: 'text',
				value: ''
		},
		{
				key: 'identifier',
				label: getIdentifierName(),
				type: 'text',
				value: ''
		},
		{
				key: 'treeId',
				label: 'Id Árvore',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'protocol',
				label: 'Protocolo',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'requester',
				label: 'Requerente',
				type: 'text',
				value: ''
		},
		{
				key: 'emailRequester',
				label: 'Email do Requerente',
				type: 'text',
				value: ''
		},
		{
				key: 'serviceType',
				label: 'Tipo de serviço',
				type: 'text',
				value: ''
		},
		{
				key: 'data',
				label: 'Data',
				type: 'date',
				value: ''
		},
		{
				key: 'address',
				label: 'Endereço',
				type: 'text',
				value: ''
		},
		{
				key: 'region',
				label: 'Região',
				type: 'text',
				value: ''
		},
		{
				key: 'osa',
				label: 'OSA',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'schedule',
				label: 'Agendamento',
				type: 'date',
				value: ''
		},
		{
				key: 'evaluator',
				label: 'Avaliador',
				type: 'text',
				value: ''
		}
]

export const searchTruncatedDemandHistory = [
		{
				key: 'process',
				label: 'Processo',
				type: 'text',
				value: ''
		},
		{
				key: 'identifier',
				label: getIdentifierName(),
				type: 'text',
				value: ''
		},
		{
				key: 'treeId',
				label: 'Id Árvore',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'osa',
				label: 'OSA',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'data',
				label: 'Data',
				type: 'date',
				value: ''
		},
		{
				key: 'requester',
				label: 'Requerente',
				type: 'text',
				value: ''
		},
		{
				key: 'emailRequester',
				label: 'Email do Requerente',
				type: 'text',
				value: ''
		},
		{
				key: 'protocol',
				label: 'Protocolo',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'evaluator',
				label: 'Avaliador',
				type: 'text',
				value: ''
		},
		{
				key: 'address',
				label: 'Endereço',
				type: 'text',
				value: ''
		},
		{
				key: 'region',
				label: 'Região',
				type: 'text',
				value: ''
		},
		{
				key: 'operation',
				label: 'Operação',
				type: 'text',
				value: ''
		},
		{
				key: 'communication',
				label: 'N° Comunicado',
				type: 'text',
				value: ''
		}

]

export const searchTruncatedOperationServiceSchedule = [
		{
				key: 'process',
				label: 'Processo',
				type: 'text',
				value: ''
		},
		{
				key: 'identifier',
				label: getIdentifierName(),
				type: 'text',
				value: ''
		},
		{
				key: 'treeId',
				label: 'Id Árvore',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'osa',
				label: 'OSA',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'data',
				label: 'Data',
				type: 'date',
				value: ''
		},
		{
				key: 'address',
				label: 'Endereço',
				type: 'text',
				value: ''
		},
		{
				key: 'region',
				label: 'Região',
				type: 'text',
				value: ''
		},
		{
				key: 'operation',
				label: 'Operação',
				type: 'text',
				value: ''
		},
		{
				key: 'oso',
				label: 'OSO',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'schedule',
				label: 'Agendamento',
				type: 'date',
				value: ''
		},
		{
				key: 'operator',
				label: 'Operador',
				type: 'text',
				value: ''
		},
		{
				key: 'companyServiceProvider',
				label: 'Empresa',
				type: 'text',
				value: ''
		},
		{
				key: 'communication',
				label: 'N° Comunicado',
				type: 'text',
				value: ''
		}
]

export const searchTruncatedOperationServiceHistory = [
		{
				key: 'process',
				label: 'Processo',
				type: 'text',
				value: ''
		},
		{
				key: 'identifier',
				label: getIdentifierName(),
				type: 'text',
				value: ''
		},
		{
				key: 'treeId',
				label: 'Id Árvore',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'data',
				label: 'Data',
				type: 'date',
				value: ''
		},
		{
				key: 'requester',
				label: 'Requerente',
				type: 'text',
				value: ''
		},
		{
				key: 'oso',
				label: 'OSO',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'operator',
				label: 'Operador',
				type: 'text',
				value: ''
		},
		{
				key: 'companyServiceProvider',
				label: 'Empresa',
				type: 'text',
				value: ''
		},
		{
				key: 'address',
				label: 'Endereço',
				type: 'text',
				value: ''
		},
		{
				key: 'region',
				label: 'Região',
				type: 'text',
				value: ''
		},
		{
				key: 'management',
				label: 'Manejo',
				type: 'text',
				value: ''
		}
]

export const searchTruncatedTree = [
		{
				key: 'treeId',
				label: 'Id Árvore',
				type: 'text',
				value: '',
				mask: '9999999999999999999999999999999999999'
		},
		{
				key: 'specie',
				label: 'Espécie',
				type: 'text',
				value: ''
		},
		{
				key: 'address',
				label: 'Endereço',
				type: 'text',
				value: ''
		},
		{
				key: 'height',
				label: 'Altura',
				type: 'number',
				value: ''
		},
		{
				key: 'dapCap',
				label: 'DapCap',
				type: 'number',
				value: ''
		},
		{
				key: 'generalState',
				label: 'Estado geral',
				type: 'text',
				value: ''
		}
]

export class SearchTruncated {
		public key: string
		public label: string
		public type: string
		public value: string
		public mask?: string
}
